export default "__VITE_ASSET__DLWwRJKI__"